import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import reactQuery from '../../_helpers/reactQuery'
import { sellerService } from '../../_services'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Seller = function () {
  const collectionName = 'Seller'
  const singleCollectionName = 'Seller'
  const queryKey = collectionName.toLowerCase()
  const [body, setBody] = useState({})
  const defaultQueryParams = {}
  const [queryParams, setQueryParams] = useState(defaultQueryParams)
  const getQuery = reactQuery.getQuery(
    queryKey,
    queryParams,
    sellerService.query
  )
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <Document
      tableActions={[
        {
          buttonLabel: translate.Filters,
          buttonColor: 'primary',
          onSubmit: (args) =>
            setSearchParams({
              ...Object.fromEntries([...searchParams]),
              ...args,
              query: collectionName,
            }),
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          withForm: true,
          form: {
            title: `${translate.Filter} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'contacted',
                label: 'Contacted',
                type: 'boolean',
                value: queryParams.contacted
                  ? !(
                      JSON.parse(queryParams.contacted) &&
                      body.contacted === false
                    )
                  : '',
                required: true,
              },
            ],
          },
          withReset: true,
          resetFunction: () => setSearchParams(),
        },
      ]}
      title={collectionName}
      getQuery={getQuery}
      queryKey={queryKey}
      defaultQueryParams={defaultQueryParams}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      many
      notToShow={['contacted']}
    />
  )
}
export default Seller
